import { h, Component } from 'preact'
import ProjectsAPI from '../api/ProjectsAPI'
import Projects from '../components/Projects'
import LoadMoreProjects from '../components/LoadMoreProjects'
import MarketFilter from './MarketFilter'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      projects: [],
      count: 9,
      offset: 0,
      currentMarket: '',
      totalAmountProjects: null,
      loadedAllProjects: false,
      isLoading: true,
      error: false
    }

    this.handleLoadMore = this.handleLoadMore.bind(this)
    this.handleMarketChoice = this.handleMarketChoice.bind(this)
  }

  componentDidMount() {
    this.setCount()

    // check if href hash exists and is an integer
    if (location.hash && Number.isInteger(parseInt(location.hash.substr(1)))) {
      this.setState(
        {
          currentMarket: location.hash.substr(1)
        },
        this.fetchProjects
      )
    } else {
      this.fetchProjects()
    }
  }

  setCount() {
    if (window.innerWidth < 1280) {
      this.setState({
        count: 8
      })
    }
  }

  fetchProjects() {
    this.setState({ isLoading: true })

    ProjectsAPI.all(this.state, this.props.sub_id)
      .then(response => {
        this.setState({
          totalAmountProjects: response.headers.get('x-wp-total')
        })
        return response.json()
      })
      .then(data => {
        window.setTimeout(() => {
          this.setState({
            projects: [...this.state.projects, ...data],
            loadedAllProjects: false,
            isLoading: false
          })
          this.verifyLoadedAllPosts()
        }, 500)
      })
      .catch(error => {
        this.setState({
          error: true,
          isLoading: false
        })
      })
  }

  verifyLoadedAllPosts() {
    if (this.state.totalAmountProjects == this.state.projects.length) {
      return this.setState({
        loadedAllProjects: true
      })
    }

    return false
  }

  handleLoadMore() {
    this.setState(prevState => {
      return {
        offset: prevState.offset + this.state.count
      }
    }, this.fetchProjects)
  }

  handleMarketChoice(value) {
    this.setState(() => {
      return {
        currentMarket: value,
        projects: [],
        offset: 0
      }
    }, this.fetchProjects)
  }

  render() {
    return (
      <div className="c-projects-app">
        <Projects
          projects={this.state.projects}
          loading={this.state.isLoading}
          error={this.state.error}
          language={this.props.language}
        />

        <LoadMoreProjects
          onLoadMore={this.handleLoadMore}
          nrShowing={this.state.projects.length}
          nrAll={this.state.totalAmountProjects}
          loading={this.state.isLoading}
          language={this.props.language}
        />
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/js/projects/containers/App.js